"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropDown = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0uNzEgMS43MUwzLjMgNC4zYy4zOS4zOSAxLjAyLjM5IDEuNDEgMEw3LjMgMS43MUM3LjkzIDEuMDggNy40OCAwIDYuNTkgMEgxLjQxQy41MiAwIC4wOCAxLjA4LjcxIDEuNzF6IiBmaWxsPSIjMDAwIiBmaWxsLW9wYWNpdHk9Ii41NCIvPjwvc3ZnPg==";
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    formControl: {
      minWidth: 86
    },
    select: {
      height: 34,
      background: '#EEEEEE',
      color: 'rgba(0, 0, 0, 0.87)',
      padding: 0,
      borderRadius: 0,
      borderRight: '1px solid #E5E5E5',
      borderLeft: '1px solid #E5E5E5',
      fontFamily: 'Roboto',
      fontSize: 16,
      fontWeight: 400,
      letterSpacing: 0.15,
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
      '& .MuiSelect-select.MuiSelect-select': {
        padding: '6px 32px 6px 9px'
      },
      '& .MuiSelect-selectMenu': {
        textOverflow: 'initial'
      },
      '& .MuiSelect-icon': {
        top: 0,
        color: theme.palette.text.primary,
        padding: '15.5px 10px',
        cursor: 'pointer'
      }
    },
    item: {
      maxHeight: 36,
      minWidth: 86
    },
    options: {
      marginTop: 34,
      boxShadow: '0px 5px 5px -3px rgba (0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)!important',
      borderRadius: '4px!important',
      minWdth: 86,
      '& .MuiList-padding': {
        paddingTop: 8,
        paddingBottom: 9,
        fontSize: 16
      }
    },
    TypographyEllipsis: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  };
});
var CustomDropDown = (0, _styles.withStyles)()(function (_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("img", {
    className: className,
    src: DropDown,
    alt: "Dropdown icon"
  });
});

function SelectFilter(_ref2) {
  var filterOptions = _ref2.filterOptions,
      option = _ref2.option,
      onOptionSelect = _ref2.onOptionSelect;
  var classes = useStyles();

  var handleOptionSelect = function handleOptionSelect(opt) {
    onOptionSelect(opt);
  };

  return /*#__PURE__*/React.createElement(_core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(_core.Select, {
    id: "select-filter",
    value: option ? option.value : 'Todos',
    className: classes.select,
    MenuProps: {
      classes: {
        paper: classes.options
      }
    },
    defaultValue: option,
    disableUnderline: true,
    IconComponent: CustomDropDown,
    label: "Todos"
  }, /*#__PURE__*/React.createElement(_core.MenuItem, {
    className: classes.item,
    value: "todos",
    onClick: function onClick() {
      return handleOptionSelect({
        label: 'Todos',
        value: 'todos'
      });
    }
  }, /*#__PURE__*/React.createElement(_core.Typography, {
    variant: "body1"
  }, "Todos")), filterOptions && filterOptions.map(function (opt) {
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      className: classes.item,
      key: "".concat(opt.value, "+").concat(Math.random()),
      onClick: function onClick() {
        return handleOptionSelect(opt);
      },
      value: opt.value
    }, /*#__PURE__*/React.createElement(_core.Typography, {
      variant: "body1",
      className: classes.TypographyEllipsis
    }, opt.label));
  })));
}

SelectFilter.propTypes = {
  /** Lista de opções para o filtro select */
  filterOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string || _propTypes.default.number
  })).isRequired,

  /** Método responsável por alterar e selecionar a opção do filtro  */
  onOptionSelect: _propTypes.default.func.isRequired,

  /** Opção selecionada no filtro */
  option: _propTypes.default.string
};
SelectFilter.defaultProps = {
  option: ''
};
var _default = SelectFilter;
exports.default = _default;